import { StateService } from "@uirouter/angularjs";
import { $confirm } from "../../../../../../../@custom_types/confirm";
import { Record } from "../../../../../../records/server/crud";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../records/server/serverUtility";

export class MachineConfigurationTypeInfoComponentController {
  public readonly machineConfigurationType!: Record;

  static $inject = ["$confirm", ServerUtilityName, "$state"];
  constructor(
    private readonly $confirm: $confirm,
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService
  ) {}

  delete() {
    this.$confirm({
      text: "Are you sure you want to delete this Type Id?  Any machines with this Type Id will no longer be associated with any Type Id after deletion.",
    }).then(() =>
      this.serverUtility
        .delete({
          url: "/api/machines/MachineConfigurationType",
          id: this.machineConfigurationType.Id,
        })
        .then(() => {
          this.$state.go("^.^");
        })
    );
  }
}
